import { setBuilderToolbar } from '../../../../../Template/config/components/selection/SetBuilder'

export default {
  ...setBuilderToolbar,
  enableExcludeNonNormFilters: {
    ad: false,
    norm: false
  },
  exportButtons: {
    ad: {
      data: true,
      media: true
    },
    norm: {
      data: true,
      media: true
    }
  },
  sortOptions: [
    {
      "value": -1,
      "label": "Alpha Order by Ad Code",
      "field": "ad_code",
      "selected": false
    },
    {
      "value": 100,
      "label": "In-Market Potential Score",
      "selected": true,
      "dataFormat": ".,0"
    },
    {
      "value": 102,
      "label": "Breakthrough Potential",
      "selected": false
    },
    {
      "value": 103,
      "label": "Lift to Consideration",
      "selected": false
    },
    {
      "value": 105,
      "label": "Net Actions",
      "selected": false
    },
    {
      "value": 121,
      "label": "Creative Potential Summary Score",
      "selected": false,
      "dataFormat": ".,0"
    },
    {
      "value": 119,
      "label": "Likeability",
      "selected": false
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastPremarket/config/components/selection/SetBuilder/setBuilderToolbar.js